// The weekly sheet's decisions, shared by the web and the phone: gains only, never a tally of days.
import type { LangId } from "@aybuben/core/lang.ts";
import { STAGES, type Stage, type TreeState } from "@aybuben/core/progress/tree.ts";

export interface WeekModel {
	/** The tree reached a new stage this week. */
	grew: boolean;
	stage: Stage;
	/** How much nearer the next stage, when it did not grow and moved at all. */
	closer: { pct: number; stage: Stage } | null;
	/** Apricots that ripened since. */
	ripened: number;
	/** Units whose ribbon was tied since. */
	tied: string[];
}

export function weekModel(from: TreeState, to: TreeState): WeekModel {
	const grew = STAGES.indexOf(to.stage) > STAGES.indexOf(from.stage);
	const next = STAGES[STAGES.indexOf(to.stage) + 1];
	const pct = Math.round((to.progress - from.progress) * 100);
	return {
		grew,
		stage: to.stage,
		closer: !grew && next && pct > 0 ? { pct, stage: next } : null,
		ripened: Math.max(0, to.harvest - from.harvest),
		tied: to.ribbons.filter((u) => !from.ribbons.includes(u)),
	};
}

/** The week's start as "Monday, October 5", in the learner's language. */
export const weekDate = (since: number, lang: LangId): string =>
	new Intl.DateTimeFormat(lang, { weekday: "long", day: "numeric", month: "long" }).format(since);
